// context/ChartIndicatorContext.jsx

import { createContext, useContext, useState } from "react";

import axios from "axios";

const ChartIndicatorContext = createContext();

export const ChartIndicatorProvider = ({ children }) => {
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  /* =========================
     STATES
  ========================= */

  const [chartIndicatorLoading, setChartIndicatorLoading] = useState(false);

  const [chartIndicatorError, setChartIndicatorError] = useState(null);

  const [chartIndicatorData, setChartIndicatorData] = useState(null);

  /* =========================
     GET CHART INDICATORS
  ========================= */

  const getChartIndicators = async ({ symbol, securityId, interval = "5" }) => {
    try {
      setChartIndicatorLoading(true);

      setChartIndicatorError(null);

      const response = await axios.get(`${BASE_URL}/api/chartIndicators`, {
        params: {
          symbol,
          securityId,
          interval,
        },
      });

      console.log("Chart Indicator Response:", response.data);

      setChartIndicatorData(response.data);

      return response.data;
    } catch (err) {
      console.error("Chart indicator error:", err.message);

      setChartIndicatorError(
        err.response?.data?.message || "Failed to fetch chart indicators",
      );

      return null;
    } finally {
      setChartIndicatorLoading(false);
    }
  };

  return (
    <ChartIndicatorContext.Provider
      value={{
        chartIndicatorLoading,

        chartIndicatorError,

        chartIndicatorData,

        getChartIndicators,
      }}
    >
      {children}
    </ChartIndicatorContext.Provider>
  );
};

export const useChartIndicator = () => useContext(ChartIndicatorContext);
